<template>
  <div class="warehouse-reference-wrapper">
    <!--    <scroll-indicator @change="scrollHorizontal"/>-->
    <div class="d-flex">
      <div
        ref="wrapper"
        :style="{
          overflow: 'auto',
          maxHeight: $vuetify.breakpoint.height - 250 + 'px',
          width: '100%',
        }"
      >
        <div
          class="warehouse-view-table-navigation warehouse-view-table-navigation-horizontal text-uppercase"
        >
          <warehouse-box
            :width="row"
            v-for="(row, letterIndex) in data.columns"
            :key="`letter-${letterIndex}`"
            :class="['warehouse-index-top-box']"
            class="warehouse-view-table-navigation__text-style"
          >
            {{ getLetter(letterIndex) }}
          </warehouse-box>
        </div>
        <div class="d-flex">
          <div
            class="warehouse-view-table-navigation warehouse-view-table-navigation-vertical"
          >
            <warehouse-box
              :height="item"
              :key="`row-${index}`"
              :class="['warehouse-index-left-box']"
              v-for="(item, index) in data.rows"
              class="warehouse-view-table-navigation__text-style"
              >{{ index }}
            </warehouse-box>
          </div>
          <div class="d-flex text-uppercase table-cell-wrapper">
            <!-- +=+=+=+=++=+=+=+=+ |columns start| +=+=+=+=++=+=+=+=+ -->
            <div
              v-for="(column, columnIndex) in data.boards"
              :key="columnIndex"
            >
              <warehouse-box
                @click="
                  boxClickHandler({
                    event: $event,
                    rowIndex,
                    columnIndex,
                    columnId: row.columnId || null,
                    cellId: row.id || null,
                  })
                "
                @changeWidth="
                  changeBoxSize({
                    type: 'x',
                    rowIndex,
                    columnIndex,
                    value: $event,
                    id: row.id,
                  })
                "
                @changeHeight="
                  changeBoxSize({
                    type: 'y',
                    rowIndex,
                    columnIndex,
                    value: $event,
                    id: row.id,
                  })
                "
                :class="[
                  'warehouse-view-table-box warehouse-view-table-box__border',
                  `warehouse-view-table-box-${row.placeType.toLowerCase()}`,
                ]"
                :width="row.width"
                :height="row.height"
                :key="`box-${columnIndex}-${rowIndex}`"
                v-for="(row, rowIndex) in column"
                :can-resize="!!row.id"
              >
                {{ getLetter(columnIndex) }}{{ rowIndex }}
              </warehouse-box>
              <!--							<warehouse-field-box-->
              <!--								v-for="(row, rowIndex) in column"-->
              <!--								:item="row"-->
              <!--								:width="row.width"-->
              <!--								:height="row.height"-->
              <!--								:key="row.id"-->
              <!--								@changeWidth="changeBoxSize({type: 'x', rowIndex, columnIndex, value: $event, id: row.id})"-->
              <!--								@changeHeight="changeBoxSize({type: 'y', rowIndex, columnIndex, value: $event, id: row.id})"-->
              <!--								can-resize-->
              <!--								@click="boxClickHandler({event: $event, rowIndex, columnIndex, columnId:row.columnId||null, cellId: row.id||null})"-->
              <!--							>-->
              <!--								{{ getLetter(columnIndex) }}{{ rowIndex }}-->
              <!--							</warehouse-field-box>-->

              <warehouse-box
                class="warehouse-view-table-box background-white warehouse-new-view-table-box_border"
                :width="data['columns'][columnIndex]"
                :height="data['rows'][column.length]"
                @click="
                  boxAddClickHandler({
                    event: $event,
                    positionType: BOX_POSITION.row,
                    columnIndex,
                  })
                "
              >
                <img src="@/assets/img/box-plus.svg" alt="" />
              </warehouse-box>
              <!--							<div-->
              <!--								class="warehouse-view-table-box"-->
              <!--								@click="boxAddClickHandler({event: $event, positionType: BOX_POSITION.row, columnIndex})">-->
              <!--								+-->
              <!--							</div>-->
            </div>
            <!-- columns end-->

            <div class="d-flex">
              <warehouse-box
                :height="data['rows'][0]"
                class="warehouse-view-table-box background-white warehouse-new-view-table-box_border"
                @click="
                  boxAddClickHandler({
                    event: $event,
                    positionType: BOX_POSITION.col,
                  })
                "
              >
                <img src="@/assets/img/box-plus.svg" alt="" />
              </warehouse-box>
            </div>
          </div>
        </div>
      </div>
    </div>
    <context-menu
      v-model="currentItem.contextMenuVisible"
      :position="currentItem.contextMenuPosition"
      @closed="clear"
      class="warehouse-reference-wrapper__context-menu"
    >
      <div
        v-for="type in FIELD_TYPES"
        :key="type.value"
        class="d-flex align-center cursor-pointer mb-2"
      >
        <input
          :id="`type-${type.value}`"
          v-model="currentItem.placeType"
          :value="type.value"
          class="d-inline-block mr-2 pa-2"
          type="radio"
          @keyup.enter="applyClickHandler"
        />
        <label :for="`type-${type.value}`">{{ type.text }}</label>
      </div>
      <div v-if="!currentItem.isEdit">
        <custom-input-text
          hide-details
          :label="$t('row')"
          @keydown.enter="applyClickHandler"
          @keypress="numberOnly"
          v-model="currentItem.rowCount"
          style="width: 100%"
          class="user_input no-margin"
        />
      </div>
      <div class="d-flex justify-space-between mt-2">
        <v-btn
          width="45%"
          color="#DFE2E9"
          @click="currentItem.contextMenuVisible = false"
        >
          <v-icon color="#7A889B">mdi-close-circle</v-icon>
        </v-btn>
        <v-btn width="45%" color="primary" @click="applyClickHandler">
          <v-icon>mdi-check-circle</v-icon>
        </v-btn>
      </div>
    </context-menu>
    <context-menu
      v-model="currentItem.isVisibleBoxContext"
      :position="currentItem.contextMenuPosition"
      @closed="clear"
    >
      <div class="mb-3">
        <v-btn color="primary" width="100%" @click="editBoxHandler">{{
          $t("edit")
        }}</v-btn>
      </div>
      <div>
        <v-btn color="error" width="100%" @click="deleteBoxHandler">{{
          $t("delete")
        }}</v-btn>
      </div>
      <div
        v-if="
          currentItem.columnId &&
          currentItem.cellId &&
          currentItem.placeType === 'Stillage'
        "
        class="mt-3"
      >
        <v-btn color="success" width="100%" @click="gotoEditStillagePage"
          >{{ $t("warehouseFieldType.stillage") }}
        </v-btn>
      </div>
    </context-menu>
    <warning-dialog v-model="warningDialog" @apply="applyBoxDeleteHandler" />
    <NotificationSystem ref="notificationError" />
  </div>
</template>

<script>
import "./warehouse.css";
import "./warehouse-edit-table.css";
import ContextMenu from "@/components/ui/context-menu/ContextMenu";
import { DEFAULT_STILLAGE_BOX_SIZE, FIELD_TYPES } from "@/utils/constants";
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import { getLetter } from "@/utils/numeration";
// import ScrollIndicator from "@/components/ui/scroll-indicator/ScrollIndicator";
import { numberOnly } from "@/utils/inputRegExps";
// import WarehouseFieldBox from "@/components/warehouse/WarehouseFieldBox.vue";
import WarehouseBox from "@/components/warehouse/WarehouseBox.vue";
import NotificationSystem from "@/components/notificationSystem.vue";

const BOX_POSITION = {
  col: "col",
  row: "row",
  change: "change",
};
const DEFAULT_CURRENT_ITEM = {
  cellId: null,
  columnId: null,
  placeType: null,
  columnIndex: null,
  rowIndex: null,
  rowCount: null,
  positionType: BOX_POSITION.col,
  isVisibleBoxContext: false,
  contextMenuVisible: false,
  isEdit: false,
  contextMenuPosition: {
    top: 0,
    left: 0,
  },
};
export default {
  name: "warehouse-edit-table",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      warningDialog: false,
      currentItem: {
        ...DEFAULT_CURRENT_ITEM,
      },
    };
  },
  methods: {
    async requestChangeSize({ ids, width = null, height = null }) {
      try {
        const data = { ids, width, height };
        await this.$http.post("warehouse/setup-size", data);
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    changeBoxSize({ type, rowIndex, columnIndex, value }) {
      const ids = [];
      if (type === "x") {
        this.data.columns[columnIndex] = value;
        this.$set(
          this.data.boards,
          columnIndex,
          this.data.boards[columnIndex].map((item) => {
            item.width = value;
            ids.push(item.id);
            return item;
          })
        );
        this.requestChangeSize({ ids, width: value });
      }
      if (type === "y") {
        this.data.rows[rowIndex] = value;
        this.data.boards = this.data.boards.map((item) => {
          if (item[rowIndex]) {
            ids.push(item[rowIndex].id);
            item[rowIndex].height = value;
          }
          return item;
        });
        this.requestChangeSize({ ids, height: value });
      }
    },
    gotoEditStillagePage() {
      const { cellId, columnId } = this.currentItem;
      const { id: warehouseId } = this.$route.params;
      this.$router.push({
        name: "reference-warehouse-edit-stillage",
        params: {
          cellId,
          warehouseId,
          columnId,
        },
      });
    },
    editBoxHandler() {
      this.currentItem = {
        ...this.currentItem,
        contextMenuVisible: true,
        isVisibleBoxContext: false,
        positionType: BOX_POSITION.change,
      };
    },
    boxClickHandler({ event, columnIndex, rowIndex, cellId, columnId }) {
      const row = this.data.boards[columnIndex][rowIndex];
      const { clientX: left, clientY: top } = event;
      this.currentItem = {
        ...this.currentItem,
        isVisibleBoxContext: true,
        columnIndex,
        rowIndex,
        positionType: BOX_POSITION.change,
        contextMenuPosition: { top, left },
        placeType: row ? row.placeType : null,
        isEdit: true,
        cellId,
        columnId,
      };
    },
    boxAddClickHandler({
      event,
      positionType,
      columnIndex = null,
      rowIndex = null,
    }) {
      const { clientX: left, clientY: top } = event;
      this.currentItem = {
        ...this.currentItem,
        contextMenuVisible: true,
        positionType: positionType,
        columnIndex: columnIndex,
        rowIndex: rowIndex,
        contextMenuPosition: { top, left },
      };
    },
    applyClickHandler() {
      const { positionType, placeType, columnIndex, rowIndex, rowCount } =
        this.currentItem;
      if (placeType) {
        switch (positionType) {
          case BOX_POSITION.col:
            this.addColumn({ placeType, rowCount });
            break;
          case BOX_POSITION.row:
            this.addRow({ placeType, rowIndex, columnIndex, rowCount });
            break;
          case BOX_POSITION.change:
            this.changeBox({ rowIndex, columnIndex, placeType });
        }
      }
    },
    changeBox({ placeType, rowIndex, columnIndex }) {
      let boxData = this.data.boards[columnIndex][rowIndex];
      boxData = {
        ...boxData,
        placeType,
      };
      this.data.boards[columnIndex].splice(rowIndex, 1, boxData);
      this.currentItem = { ...DEFAULT_CURRENT_ITEM, placeType };
    },
    deleteBoxHandler() {
      this.warningDialog = true;
    },
    reInitBoxPosition({ columnIndex, rowIndex }) {
      if (this.data.boards[columnIndex].length - 1 !== rowIndex) {
        this.data.boards.splice(
          columnIndex,
          1,
          this.data.boards[columnIndex].map((item, index) => {
            item.position = index;
            return item;
          })
        );
      }
    },
    async applyBoxDeleteHandler() {
      const { rowIndex, columnIndex } = this.currentItem;
      if (this.data.boards[columnIndex][rowIndex].id) {
        try {
          await this.$http.delete("warehouse/delete-cell", {
            params: {
              id: this.data.boards[columnIndex][rowIndex].id,
            },
          });
          this.deleteCell(columnIndex, rowIndex);
          this.$emit("deleteCell");
        } catch (e) {
          // this.setResponseError({ error: e });
          this.$refs.notificationError.open({
            title: e.response.data.error_message.title,
          });
        } finally {
          this.clearLoading();
        }
      } else {
        this.deleteCell(columnIndex, rowIndex);
      }
      this.currentItem = { ...DEFAULT_CURRENT_ITEM };
    },
    deleteCell(columnIndex, rowIndex) {
      if (this.data.boards[columnIndex].length === 1) {
        this.data.boards.splice(columnIndex, 1);
      } else {
        this.data.boards[columnIndex].splice(rowIndex, 1);
        this.reInitBoxPosition({ columnIndex, rowIndex });
      }
    },
    clear() {
      this.currentItem = { ...DEFAULT_CURRENT_ITEM };
    },

    addColumn({ placeType, rowCount }) {
      rowCount = +rowCount;
      if (!rowCount) rowCount = 1;
      this.data.columns.push(DEFAULT_STILLAGE_BOX_SIZE);
      const columnCount = rowCount - this.data.rows.length;
      if (columnCount > 0) {
        let rows = [...this.data.rows];
        for (let i = 0; i < columnCount; i++) {
          rows.push(DEFAULT_STILLAGE_BOX_SIZE);
        }
        this.data.rows = rows;
      }
      this.data.boards.push(this.createRow({ placeType, rowCount }));
      this.currentItem = { ...DEFAULT_CURRENT_ITEM, placeType };
    },
    createRow({ rowCount = 1, placeType }) {
      if (rowCount > 15) rowCount = 15;
      const rows = [];
      const offsetCount =
        this.currentItem.columnIndex !== null
          ? this.data.boards[this.currentItem.columnIndex].length
          : 0;
      for (let i = 0; i < rowCount; i++) {
        let height = DEFAULT_STILLAGE_BOX_SIZE;
        let width = DEFAULT_STILLAGE_BOX_SIZE;
        if (this.data.rows[i + offsetCount])
          height = this.data.rows[i + offsetCount];
        if (this.currentItem.columnIndex !== null)
          width = this.data.columns[this.currentItem.columnIndex];
        rows.push({
          placeType,
          height,
          width,
        });
      }
      return rows;
    },
    addRow({ columnIndex, placeType, rowCount }) {
      rowCount = +rowCount;
      if (!rowCount) rowCount = 1;
      const columnCount =
        rowCount + this.data.boards[columnIndex].length - this.data.rows.length;
      if (columnCount > 0) {
        let rows = [...this.data.rows];
        for (let i = 0; i < columnCount; i++) {
          rows.push(DEFAULT_STILLAGE_BOX_SIZE);
        }
        this.data.rows = rows;
      }
      this.data.boards[columnIndex] = [
        ...this.data.boards[columnIndex],
        ...this.createRow({ placeType, rowCount }),
      ];
      this.currentItem = { ...DEFAULT_CURRENT_ITEM, placeType };
    },
  },
  components: {
    NotificationSystem,
    WarehouseBox,
    // WarehouseFieldBox,
    // ScrollIndicator,
    WarningDialog,
    ContextMenu,
  },
  computed: {
    FIELD_TYPES() {
      return FIELD_TYPES.map((item) => {
        return {
          text: this.$t(`warehouseFieldType.${item.text}`),
          value: item.value,
        };
      });
    },
    BOX_POSITION: () => BOX_POSITION,
    getLetter: () => getLetter,
    numberOnly: () => numberOnly,
  },
};
</script>
